import { render, staticRenderFns } from "./VectorSelectInterview.vue?vue&type=template&id=3204bc13"
import script from "./VectorSelectInterview.vue?vue&type=script&lang=js"
export * from "./VectorSelectInterview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports